var map = {
	"./arrow-down.svg": 13237,
	"./arrow-downward.svg": 8744,
	"./arrow-left.svg": 74059,
	"./arrow-right.svg": 17726,
	"./arrow-up.svg": 89531,
	"./arrow-upward.svg": 4110,
	"./bell.svg": 78686,
	"./bigcommerce.svg": 47082,
	"./bold.svg": 9983,
	"./build.svg": 53536,
	"./capital.svg": 24094,
	"./carousel.svg": 70093,
	"./center-alignment.svg": 14376,
	"./chat.svg": 40913,
	"./check-checked.svg": 48523,
	"./check-empty.svg": 14158,
	"./check.svg": 24584,
	"./chev-bottom-thin.svg": 11922,
	"./chev-bottom.svg": 97597,
	"./chev-left.svg": 20965,
	"./chev-right.svg": 92942,
	"./chevrons-up.svg": 47814,
	"./circle-check-filled.svg": 90153,
	"./circle-check-shape.svg": 82570,
	"./circle-info-blue.svg": 22182,
	"./circle-info.svg": 63080,
	"./circle-mark.svg": 1998,
	"./circle.svg": 82961,
	"./clock.svg": 64892,
	"./close.svg": 15190,
	"./content.svg": 6165,
	"./copied.svg": 81258,
	"./copy.svg": 92431,
	"./cross.svg": 95511,
	"./date-range.svg": 56337,
	"./download.svg": 27359,
	"./edit.svg": 5340,
	"./enter.svg": 44065,
	"./error-outline.svg": 35613,
	"./facebook.svg": 24195,
	"./filters-left.svg": 38967,
	"./filters-right.svg": 70726,
	"./filters-top.svg": 36202,
	"./filters.svg": 6145,
	"./font.svg": 31563,
	"./gift.svg": 2132,
	"./globe.svg": 46924,
	"./grid-system.svg": 49949,
	"./grid.svg": 71832,
	"./hamburger.svg": 11525,
	"./heart.svg": 65330,
	"./hide.svg": 762,
	"./home.svg": 73417,
	"./icons/arrow-down.svg": 64060,
	"./icons/cross.svg": 92023,
	"./icons/empty.svg": 36261,
	"./info-maropost.svg": 13304,
	"./info-sign.svg": 13501,
	"./info.svg": 26907,
	"./italic.svg": 20509,
	"./javascript.svg": 76644,
	"./left-alignment.svg": 14531,
	"./linkedin.svg": 5082,
	"./loading.svg": 27880,
	"./lock.svg": 21878,
	"./log-out.svg": 82540,
	"./low-priority.svg": 95701,
	"./magento.svg": 72114,
	"./mail.svg": 78388,
	"./mark.svg": 79831,
	"./more-vert.svg": 75889,
	"./more.svg": 44793,
	"./move.svg": 63,
	"./notification.svg": 83606,
	"./ok.svg": 78815,
	"./pencil.svg": 53796,
	"./person-outline.svg": 66587,
	"./person.svg": 18222,
	"./pie-chart.svg": 98092,
	"./pin-fill.svg": 57418,
	"./pin-outline.svg": 3185,
	"./plane.svg": 83912,
	"./play.svg": 87679,
	"./plug.svg": 41287,
	"./plus-thin.svg": 43861,
	"./plus.svg": 99707,
	"./product-horizontal.svg": 1292,
	"./product-vertical.svg": 70893,
	"./right-arr.svg": 65526,
	"./round-help.svg": 99341,
	"./search.svg": 44077,
	"./server.svg": 4994,
	"./settings.svg": 76237,
	"./shopify-icon.svg": 98414,
	"./shopify.svg": 52736,
	"./show.svg": 20775,
	"./slider.svg": 11345,
	"./sync.svg": 87588,
	"./thin-cross.svg": 49912,
	"./thumb-down.svg": 81305,
	"./thumb-up.svg": 83512,
	"./trash.svg": 36115,
	"./tune.svg": 55382,
	"./twitter.svg": 44841,
	"./upper.svg": 9601,
	"./view-carousel.svg": 19700,
	"./view-compact.svg": 57393,
	"./volusion.svg": 81254,
	"./white-bottom-arrow.svg": 58021,
	"./woocommerce.svg": 57136,
	"./youtube.svg": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57244;